'use strict';

module.exports = require('./Input');